export const LIST_AUTHORS = `
	query ListAuthors($first: Int, $groups: [String!], $licenseTypes: [LicenseTypeEnum!]) {
		users(first: $first, groups: $groups, memberType: EMPLOYEE, licenseTypes: $licenseTypes) {
			nodes {
				id
				databaseId
				name
				firstName
				lastName
				email
				username
				permalink
				licenses {
					nodes {
						id
						expiresAt
						type
						product
						state
						user {
							id
							databaseId
						}
						organization {
							id
							slug
						}
					}
				}
			}
		}
	}
`;

export const GET_USERS_BY_IDS = `
	query GetUsers($databaseIds: [String!]) {
		users(databaseIds: $databaseIds) {
			nodes {
				id
				databaseId
				name
				licenses(first: 100) {
					nodes {
						id
						type
					}
				}
			}
		}
	}
`;

export const SEARCH_USERS_AND_GROUPS = `
	query SearchUsersAndGroups($fullText: String!, $licenseTypes: [LicenseTypeEnum!]) {
	  viewer {
	    id
	    organization {
		    usersAndGroups(
		      memberType: EMPLOYEE,
		      licenseTypes: $licenseTypes,
		      fullText: $fullText,
		      orderBy: { attribute: "name", direction: ASC }
		    ) {
		      ... on User {
		        id
		        databaseId
		        name
		        initials
		        avatar {
		          fileUrl
		        }
		        licenses {
		          nodes {
		            id
		            type
		          }
		        }
		      }
		      ... on Group {
		        id
		        databaseId
		        name
		        members {
		          totalCount
		        }
		      }
		    }
	    }
	  }
	}
`;

export const UPDATE_VIEWER = `
	mutation UpdateViewer($input: UpdateUserMutationInput!) {
		updateUser(input: $input) {
			user {
				id
				databaseId
				name
				wlcProfileSettings {
					id
					lastLogin
					eulaVersionConfirmed
					releaseNotesVersionSeen
					projectListSeen
					wlcSettings
				}
			}
			errors {
				message
				fullMessage
				path
				type
			}
		}
	}
`;